<template>
	<div class="col-md-12 col-lg-6 col-xl-4 px-0">
		<div class="card class-feature m-2">
			<div class="card-header" :class="{'py-3': (index == 0 && level % 2 != 0) }">
				<span class="h6">Feat</span>
				<button class="btn btn-sm btn-danger float-right" @click="$emit('discard',index)" v-if="index != 0 || level % 2 == 0">&times;</button>
			</div>
			<div class="card-body p-0">
				<input type="text" class="form-control" v-model="feat.Name" />
				<expanding-textarea>
					<template v-slot:default="{resize}">
						<textarea
						class="form-control"
						@input="resize"
						v-model.lazy="feat.Description"
						></textarea>
					</template>
				</expanding-textarea>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: [
		'level',
		'index',
		'feat',
	],
	watch: {
		feat: {
			deep: true,
			handler: function(value){
				this.$store.commit('setCharacterProp',[
					{
						key: `Levels[${this.level}].Feats[${this.index}]`,
						val: value,
					}
				])
			}
		}
	}
}
</script>

<style scoped>
input {
	border-color: transparent;
	border-radius: 0px;
}
textarea {
	border-radius: 0px;
	border-bottom-color: transparent;
	border-left-color: transparent;
	border-right-color: transparent;
	border-bottom-left-radius: 3px;
	border-bottom-right-radius: 3px;
	top: -2px;
}
</style>